<template>
  <v-card outlined class="mx-auto my-4">
    <v-card-text>
      <v-row>
        <v-col
          v-for="url in urlFilters.displayedUrls.value"
          :key="url.pathname"
          cols="12"
          sm="6"
          md="4"
        >
          <UrlCard :item="url" />
        </v-col>
      </v-row>

      <!-- New Section: Category Hub Source Details in an Expansion Panel -->
      <v-expansion-panels class="mt-4">
        <v-expansion-panel>
          <v-expansion-panel-title>
            Category Hub Source Information
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <v-card outlined>
              <v-card-text>
                <div v-if="categoryHubSource.length">
                  <div v-for="(source, index) in categoryHubSource" :key="index">
                    <div><strong>Pathname:</strong> {{ source.pathname }}</div>
                    <div><strong>URL Source:</strong> {{ source.urlSource }}</div>
                  </div>
                </div>
                <div v-else>
                  No Category Hub Source information available.
                </div>
              </v-card-text>
            </v-card>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import UrlCard from './UrlCard.vue';
import UrlTypes from '@/enums/UrlTypes';
import { useUrlFilters } from '@/composables/useUrlFilters';
import { useUrlSourcesStore } from '@/store/urlSourcesStore';

// Filter for URLs classified as Category Hub.
const urlFilters = useUrlFilters((url) => url.urlType === UrlTypes.CATEGORY_HUB);

// Get the URL sources store instance from Pinia and create a computed reference for the category hub source.
const urlSourcesStore = useUrlSourcesStore();
const categoryHubSource = computed(() => urlSourcesStore.getCategoryHubSources);
</script>
